import React from 'react'
import { useOn, useTracking, useLogger } from 'hooks'
import { connect, Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ThemeProvider } from 'styled-components'

import store, { history } from 'store'
import { ConfirmEmail, ThemeEditor, ThemePreview } from 'components/Modal'
import GlobalStyles from './GlobalStyles'
import Routes from 'pages/Routes'
import DevWarnings from './DevWarnings'
import ModalsWrapper from './ModalsWrapper'
import ScrollResetter from './ScrollResetter'
import NotificationPoller from './NotificationPoller'
import OfferPopupContainer from './OfferPopupContainer'

const ConnectedThemedProvider = connect(s => ({ theme: s.siteConfig.styles }))(ThemeProvider)

window.selectBlurs = []

const Tracker = () => {
  useTracking(history)
  return null
}

const Logger = () => {
  useLogger(history)
  return null
}

const AppWrapper = () => {
  useOn('click', e => window.selectBlurs.forEach(onBlur => onBlur(e)))

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ConnectedThemedProvider>
          <ScrollResetter />
          <ConfirmEmail />
          <GlobalStyles />
          <Tracker />
          <Logger />
          <Routes />
          <NotificationPoller />
          <ThemeEditor />
          <ThemePreview />
          <DevWarnings />
          <ModalsWrapper />
          <OfferPopupContainer />
        </ConnectedThemedProvider>
      </ConnectedRouter>
    </Provider>
  )
}

export default AppWrapper
